import { FC, useContext, useEffect, useState } from 'react';
import { Modal } from '@hdi-seguros/web-components.modal';
import { MasterContext } from '../../../../shared/contexts';
import { Button, Checkbox, Typography } from 'antd';
import './index.css';

const PopUpHome: FC = () => {
    const [openModal, setOpenModal] = useState(false);

    const [dontShowAgain, setDontShowAgain] = useState(false);
    const [disableModalCheckbox, setDisableModalCheckbox] = useState(false);

    const { globalPublicConfigs } = useContext(MasterContext);

    const s3Url = process.env.REACT_APP_S3_URL;

    useEffect(() => {
        const alreadySeenThisSession = sessionStorage.getItem('modalShown') === 'true';

        if (globalPublicConfigs && globalPublicConfigs.ALLOW_HOME_POPUP && !alreadySeenThisSession) {
            if (globalPublicConfigs.CAN_SKIP_POPUP) {
                const hideModal = localStorage.getItem('hideHomeModal');
                if (hideModal === 'true') {
                    return setOpenModal(false);
                }
            } else {
                setDisableModalCheckbox(true)
            }
            sessionStorage.setItem('modalShown', 'true');
            return setOpenModal(true)
        }

        /* eslint-disable-next-line  */
    }, []);

    const handleAccept = () => {
        if (dontShowAgain) {
            localStorage.setItem('hideHomeModal', 'true');
        }
        setOpenModal(false);
    };

    const footerModal = () => {
        return (
            <div className='home-modal-footer'>
                <Checkbox
                    disabled={disableModalCheckbox}
                    checked={dontShowAgain}
                    onChange={(e) => setDontShowAgain(e.target.checked)}
                >
                    <Typography.Text>No mostrar nuevamente</Typography.Text>
                </Checkbox>
                <div>
                </div>
                <div>
                    <Button type='default' className='home-modal-button' onClick={() => executeCallToAction()}> Descargar </Button>
                    <Button type='primary' className='home-modal-button' onClick={() => handleAccept()}> Aceptar </Button>
                </div>
            </div>
        )
    }

    const executeCallToAction = async () => {
        const url = `${s3Url}${globalPublicConfigs?.CALL_TO_ACTION_FILE_NAME}`;
        try {
            const res = await fetch(url, { cache: 'no-store' });
            if (!res.ok) throw new Error('Network response was not ok');
            const blob = await res.blob();
            const objectUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = globalPublicConfigs?.CALL_TO_ACTION_FILE_NAME!;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(objectUrl);
        } catch (e) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <Modal footer={footerModal} closable={false} className="home-modal-container" open={openModal} >
            <div className='home-modal-image-container'>
                <img className='home-modal-image' src={`${s3Url}popup_home.png`} alt="modal-image" />
            </div>
        </Modal>
    );
}

export default PopUpHome;